<ix-modal-header
  [requiredRoles]="requiredRoles"
  [title]="'System Security' | translate"
></ix-modal-header>

<mat-card class="card">
  <mat-card-content>
    <form class="ix-form-container" [formGroup]="form" (submit)="onSubmit()">
      <ix-slide-toggle
        formControlName="enable_fips"
        color="primary"
        [label]="'Enable FIPS' | translate"
        [tooltip]="'Enforce the use of FIPS 140-2 compliant algorithms' | translate"
      ></ix-slide-toggle>

      <p>
        {{ 'Restart is required after changing this setting.' | translate }}
      </p>

      <div class="form-actions">
        <button
          *ixRequiresRoles="requiredRoles"
          mat-button
          type="submit"
          color="primary"
          ixTest="save"
          [disabled]="!form.valid"
        >
          {{ 'Save' | translate }}
        </button>
      </div>
    </form>
  </mat-card-content>
</mat-card>
